import { HubConnection } from './HubConnection'

export const HUB_PUSH_NOTIFICATION = 'push-notification'
export const HUB_AUDIT = 'audit'

class HubPool {
  private connections: Map<string, HubConnection> = new Map()
  private hubs: string[] = [HUB_PUSH_NOTIFICATION, HUB_AUDIT]

  public async init() {
    this.createConnection()
    this.connections.forEach(async (value, key) => {
      await value.init(key)
    })
  }

  public getHub = (hub: string): HubConnection | null => {
    return this.connections.get(hub) || null
  }

  private createConnection() {
    for (const hub of this.hubs) {
      const connection = new HubConnection()
      if (this.connections) {
        this.connections.set(hub, connection)
      }
    }
  }
}

const hubPool = new HubPool()
export { hubPool }
